import development from './development';
import staging from './staging';
import production from './production';
import { getEnvironment } from './environment';

const env = getEnvironment();

const configs = {
  development,
  staging,
  production,
};

const config = configs[env];

export default config;
